import React, { Component } from "react";
import { Button, Modal, ModalBody, ModalFooter, UncontrolledAlert } from "reactstrap";
import { Spinner } from "./Spinner";
import Formsy from "formsy-react";
import { TextInput } from "../Shared/Forms";
import NutrientsCaloriesForm from "../Admin/FoodLibrary/NutrientsCaloriesForm";
class FoodLibraryModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            canSubmit: false,
            submitBottonClick: false,
            formData: null,
            errorFromNutrients: false,
            submitting: false,
            submitted: false,
        };

        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal,
        });
    }
    disableButton = () => {
        this.setState({ canSubmit: false });
    };

    enableButton = () => {
        this.setState({ canSubmit: true });
    };

    returnDataFromNutrientValue = (data) => {
        try {
            if (data) {
                let refineData = [
                    {
                        name: this.state.formData.name,
                        nutrients: [{ key: "calories", value: this.state.formData.calories }],
                    },
                ];

                for (let i = 0; i < data.length; i++) {
                    refineData[0].nutrients.push(data[i]);
                }

                setTimeout(() => {
                    this.setState({ submitBottonClick: false });
                }, 2000);

                //call the submit form from manager here.
               
                //this.props.formSubmit(refineData[0]);
            }
        } catch (e) {
            console.error(e);
        }
    };

    validateNutrients = (error) => {
        this.setState({ errorFromNutrients: error });
    };

    handleSubmit = (data) => {
        this.setState({ submitBottonClick: true, formData: data }, () => {});
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.submitted) {
            this.resetForm();
        }
    }

    resetForm = () => {
        this.refs.foodLibraryForm.reset();
        this.props.resetButton();
    };

    reset = () => {
        this.props.resetButton();
        this.resetForm();
    };
    resetButton = () => {
        this.setState({});
    };
    render() {
        const { canSubmit, submitBottonClick, errorFromNutrients, submitting, submitted } = this.state;
        const { message,  isOpen, showModal, item, error, actionState } = this.props;
        const modalError = error || (actionState && actionState.error);
        return (
            <div>
                <Modal isOpen={isOpen || this.state.modal} toggle={this.toggle} className={this.props.className}>
                    <Formsy ref="foodLibraryFormmodal" onValidSubmit={this.handleSubmit} onValid={this.enableButton} onInvalid={this.disableButton} noValidate>
                        <ModalBody>
                            {modalError ? <UncontrolledAlert color="danger">{modalError.message}</UncontrolledAlert> : null}
                            {message || "Create Food Items"}
                            <br />

                            <TextInput
                                name="name"
                                value={null}
                                required
                                disabled={submitting}
                                title="Name"
                                validations={{
                                    minLength: 3,
                                    maxLength: 50,
                                }}
                                validationErrors={{
                                    minLength: "Minimum of 3 characters allowed",
                                    maxLength: "Maximum of 50 characters allowed",
                                }}
                            />
                            <TextInput
                                name="calories"
                                required
                                value={null}
                                disabled={submitting}
                                title="Total Calories"
                                validations={{
                                    isNumeric: true,
                                }}
                                validationErrors={{
                                    isNumeric: "Whole numbers or decimals numbers only allowed",
                                }}
                            />
                            <NutrientsCaloriesForm
                                submitted={submitted}
                                valueKey="id"
                                disabled={false}
                                innerRef={(c) => {
                                    this.caloriesForm = c;
                                }}
                                isRequired={false}
                                name="caloriesId"
                                title="Select Nutrients
                    "
                                returnDataFromNutrientValue={this.returnDataFromNutrientValue}
                                submitBottonClick={submitBottonClick}
                                resetButton={this.resetButton}
                                validateNutrients={this.validateNutrients}
                            />
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" type="submit" disabled={!canSubmit || submitting || errorFromNutrients}>
                                {submitting ? <Spinner /> : "Creat Food Items"}
                            </Button>{" "}
                            <Button color="secondary" onClick={() => showModal(item)}>
                                No
                            </Button>
                        </ModalFooter>
                    </Formsy>
                </Modal>
            </div>
        );
    }
}

export default FoodLibraryModal;
